import React from 'react';
import Icon from '@atlaskit/icon';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import multipleFlagsIconUrl from './assets/multiple-flags.svg';
import messages from './messages.tsx';

const MultipleFlagsGlyph = () => <img src={multipleFlagsIconUrl} alt="" />;

interface MultipleFlagsIconProps {
	label: string;
	testId?: string;
}

export const MultipleFlagsBaseIcon = ({ label, testId }: MultipleFlagsIconProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={label || undefined}
		role={label ? 'img' : 'presentation'}
		data-testid={testId}
	>
		<rect width="24" height="24" fill="white" fill-opacity="0.01" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6 12.235V18.681C6 19.218 6.45 19.658 7 19.658C7.55 19.658 8 19.218 8 18.681V12.903C9.17 12.562 10.389 12.858 11.768 13.193C12.75 13.431 13.804 13.688 14.898 13.688C15.7793 13.6974 16.6509 13.5034 17.445 13.121C17.6139 13.039 17.7562 12.9111 17.8558 12.7519C17.9554 12.5927 18.0081 12.4088 18.008 12.221V5.46601C18.0086 5.29627 17.966 5.12918 17.884 4.98052C17.8021 4.83186 17.6836 4.70656 17.5397 4.61647C17.3959 4.52637 17.2314 4.47445 17.0619 4.46562C16.8924 4.45679 16.7234 4.49135 16.571 4.56601C15.226 5.22001 13.84 4.88301 12.24 4.49501C10.511 4.07501 8.553 3.60001 6.562 4.56701C6.39348 4.64912 6.25143 4.77695 6.15205 4.93591C6.05268 5.09486 6 5.27855 6 5.46601V12.235ZM9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V6.83601C14.52 7.10601 13.078 6.75601 11.768 6.43801C10.389 6.10301 9.17 5.80601 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755V10.755Z"
			fill="#42526E"
		/>
		<path
			d="M15.1961 16.6163C14.1026 16.6505 12.7503 16.4306 11.7683 16.1926C10.8189 15.9619 9.9453 15.7498 9.11133 15.7513V13.7546C10.2053 13.7546 11.2593 14.0106 12.2403 14.2496C13.5644 14.5708 14.7163 14.7328 15.8637 14.5775C16.5226 14.4883 17.1759 14.3074 17.4825 14.1818C17.789 14.0562 18.1584 13.8224 18.3892 13.6168C18.5875 13.4403 18.7308 13.3284 18.8112 13.1375C18.8916 12.9465 18.9028 12.6541 18.8998 12.263C18.8951 11.6539 18.8998 11.1881 18.8998 11.1881V8.83656V7.46656C18.8998 7.38207 18.954 7.14726 19.0353 6.98106C19.1165 6.81486 19.2136 6.72615 19.3488 6.61701C19.484 6.50787 19.6887 6.44629 19.8918 6.44629C20.0949 6.44629 20.2877 6.52691 20.4315 6.61701C20.5754 6.70711 20.6939 6.83241 20.7758 6.98106C20.8577 7.12972 20.9004 7.29682 20.8998 7.46656C20.8998 7.46656 20.9149 11.4111 20.9149 12.1143C20.9149 12.8174 20.8866 13.4212 20.796 13.7732C20.7358 14.0071 20.6506 14.2229 20.4969 14.4463C20.3109 14.7167 19.9214 15.0215 19.7274 15.1572C19.4008 15.3856 18.9031 15.7399 18.1801 16.0215C17.1827 16.41 16.1407 16.5867 15.1961 16.6163Z"
			fill="#42526E"
		/>
	</svg>
);

export const MultipleFlagsIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return fg('enghealth-custom-icon-migration') ? (
		<MultipleFlagsBaseIcon
			label={formatMessage(messages.multipleFlagsIconLabel)}
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple"
		/>
	) : (
		// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
		<Icon
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple"
			size="medium"
			glyph={MultipleFlagsGlyph}
			label={formatMessage(messages.multipleFlagsIconLabel)}
		/>
	);
};
